import React from 'react'
import {Link}  from 'react-router-dom'
import Logo from '../../images/logo512.png'
import Newsletter from '../Newsletter'
import './style.css'

const Footer = (props) =>{

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

  return(
    <div className={`wpo-ne-footer ${props.footerClass}`}>
        <Newsletter/>
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="Dar-ul-Quran Academy" />
                                </div>
                                <p>Dar-ul-Quran Academy offers high-quality online Quran learning for UK Muslim families with flexible schedules, qualified tutors, and personalized attention.</p>
                                <ul>
                                    <li><a href="https://facebook.com/thedarulquran" target="_blank" rel="noopener noreferrer"><i className="ti-facebook"></i></a></li>
                                    <li><a href="https://instagram.com/thedarulquran" target="_blank" rel="noopener noreferrer"><i className="ti-instagram"></i></a></li>
                                    <li><a href="https://youtube.com/c/DarulQuranAcademy" target="_blank" rel="noopener noreferrer"><i className="ti-youtube"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Our Courses</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/basic-qaida">Basic Qaida</Link></li>
                                    <li><Link onClick={ClickHandler} to="/tajweed">Tajweed</Link></li>
                                    <li><Link onClick={ClickHandler} to="/tajweed-improvement">Tajweed Improvement</Link></li>
                                    <li><Link onClick={ClickHandler} to="/hifz">Hifz (Memorisation)</Link></li>
                                    <li><Link onClick={ClickHandler} to="/service">All Courses</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-2 col-md-6 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Quick Links</h3>
                                </div>
                                <ul>
                                    <li><Link onClick={ClickHandler} to="/about">About Us</Link></li>
                                    <li><Link onClick={ClickHandler} to="/service">Services</Link></li>
                                    <li><Link onClick={ClickHandler} to="/contact">Book Free Trial</Link></li>
                                    <li><Link onClick={ClickHandler} to="/blog">Blog</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 offset-lg-1 col-md-6 col-12">
                            <div className="widget market-widget wpo-service-link-widget">
                                <div className="widget-title">
                                    <h3>Contact Us</h3>
                                </div>
                                <p>Have questions or ready to enroll? We're here to help UK families on their Quran-learning journey.</p>
                                <div className="contact-ft">
                                    <ul>
                                        <li><i className="fi flaticon-call"></i><a href="https://wa.me/message/UTB4XLJQLZ22M1">+44 784 035 7821</a></li>
                                        <li><i className="fi flaticon-envelope"></i><a href="mailto:info@thedarulquran.com">info@thedarulquran.com</a></li>
                                        <li><i className="fi ti-world"></i><Link onClick={ClickHandler} to="/contact">Service Area: All across UK</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12">
                            <p className="copyright">&copy; 2025 Dar-ul-Quran Academy UK. All rights reserved</p>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="developer-credit text-lg-end">
                                <p>Designed and developed by <a href="https://apexitsolutions.co/" target="_blank" rel="noopener noreferrer">Apex IT Solutions</a> and <a href="https://www.apexmarketings.com/" target="_blank" rel="noopener noreferrer">Apex Marketings</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
  )
} 

export default Footer;